import NotFoundPage from "pages/not-found";
import {
  ProjectContext,
  TProjectContext,
  isPermissionNotGrantted
} from "context/ProjectProvider";
import { useContext } from "react";
import RiskReport from "./risk-report";
import { ErrorMessages, ProjectPermissionEnum } from "../../constants";

function RiskReportPage() {
  const { tokenContents }: TProjectContext = useContext(ProjectContext);

  const cannotViewProjectReports = tokenContents
    ? isPermissionNotGrantted(
        ProjectPermissionEnum.ViewProjectReports,
        tokenContents?.role
      )
    : false;

  if (cannotViewProjectReports) {
    return (
      <NotFoundPage
        status="403"
        title="403"
        subTitle={ErrorMessages.UnauthorizedPageAccess}
      />
    );
  }

  return <RiskReport />;
}

export default RiskReportPage;
